import type { EventType } from '@liveHelper/tracking/eventType'
import type { WidgetClickTarget } from '@liveHelper/tracking/types'

import { customEvent } from '@core/customEvent'

interface CustomLiveHelperEventPayload {
  widget_id: string | undefined
  rating?: number
  feedback?: string
  page_url?: string
  agent_id?: string
  agent_name?: string
  click_target?: WidgetClickTarget
}

/**
 * Custom event function to emit live helper events
 */
export function customLiveHelperEvent({
  type,
  data,
}: {
  type: EventType
  data: CustomLiveHelperEventPayload
}) {
  return customEvent({
    type,
    // Because data in customEvent can be any object,
    // we are typecasting here so the payload type can be validated above
    data: data as unknown as Record<string, unknown>,
  })
}
